import formatSizeNames from '../../utils/formatSizeNames';

/**
 * Adds an event handler to all add to cart buttons that allows us to async add items to the cart
 */
const addToCartBtnInit = async () => {
  const addToCartBtns = document.querySelectorAll('[data-add-to-cart]');

  addToCartBtns.forEach(async(btn: HTMLElement) => {
    btn.addEventListener('click', async e => {
      e.preventDefault();

      const el = <HTMLInputElement>e.target;
      el.classList.add('loading');
      const selector = el.dataset.atcQuantityInput;
      const productTitle = el.dataset.atcProductTitle;
      const productTitleSecond = el.dataset.atcProductTitleSecond;
      const productId = parseInt(el.dataset.atcProductId);
      const productIdSecond = el.dataset.atcProductIdSecond ? parseInt(el.dataset.atcProductIdSecond) : null;
      const input = <HTMLInputElement>document.querySelector(selector);

      const quantity = parseInt(input.value);
      const form = el.closest('form');
      const properties = {};
      let productPayload = [];
      let sellingPlanId = null;

      let _esid;
      try {
        _esid = window['EasySizeParametersDebug'].easysize.pageview_id.toString();
      } catch(e) {
        _esid = '-1'
      }

      if ( _esid !== '-1' ) {
        properties['_esid'] = _esid
      }

      if(!el.hasAttribute('data-atc-coord')){

        const inputProductId = form ? <HTMLInputElement>form.querySelector('[data-input-properties-id]') : null;
        const inputProductImage = form ?  <HTMLInputElement>form.querySelector('[data-input-properties-image]') : null;

        const sellingPlanElements: NodeListOf<HTMLInputElement> = form ? form.querySelectorAll('[name^=selling_plan]') : null;
        const sellingPlanDataAttr = form ? form.querySelectorAll('[data-atc-subscription-upsell-id]') : null;

        if(window['ReChargeWidget'] && window['ReChargeWidget'].getWidgets().length > 0){
          const sellingPlanStates = await window['ReChargeWidget'].getWidgets()[0].state;
          if (sellingPlanElements.length > 0 && sellingPlanStates) {
            sellingPlanElements.forEach((sellingPlanEl: HTMLInputElement) => {
              if(sellingPlanEl.checked || sellingPlanEl.value) {
                sellingPlanId = sellingPlanStates.sellingPlanId;
              }
            })
          }
        } else if(sellingPlanDataAttr.length !== 0 ){
          sellingPlanId = sellingPlanDataAttr[0].getAttribute('data-atc-subscription-upsell-id')
        }

        productPayload = [{ id: productId, quantity: quantity, properties, sellingPlanId }];

        if (inputProductId) {
          properties['_product_id'] = inputProductId.value;
        }
        if (inputProductImage) {
          properties['_product_image'] = inputProductImage.value;
        }

        properties['Size'] = `${ formatSizeNames(productTitle, null, null, true)}`;

        if (properties) {
          productPayload['properties'] = properties
        }

      } else {

        const firstProperties = {'Size': `${ formatSizeNames(productTitle, null, null, true)}`};
        const secondProperties = {'Size': `${ formatSizeNames(productTitleSecond, null, null, true)}`};
        
        productId ? productPayload.push({ id: productId, quantity: quantity, properties: firstProperties, sellingPlanId }) : '';
        productIdSecond ? productPayload.push({ id: productIdSecond, quantity: quantity, properties: secondProperties, sellingPlanId }) : '';

      }

      if(productPayload.length > 0){
        window['blubolt'].cart.addToCart(
          productPayload,
          true,
          () => {
            el.classList.remove('loading');
            el.classList.add('success');
            setTimeout(() => {
              el.classList.remove('success');
            }, 3000);
          }
        );
      }

    }, false);
    btn.removeAttribute('data-add-to-cart')
  })
}

export default addToCartBtnInit;